module.exports = __webpack_public_path__ + "media/metronic/_theme/media/client-logos/logo1-86fabd78d706407f378d962ff9926b60.png";